let HOST = "https://node.glamlink.net/api/v1/";
export const BASE_URL = "https://node.glamlink.net/api/v1/";
export const BASE_URL_IMAGE = "https://node.glamlink.net/api/v1/images/";
export const BASE_URL_VIDEO = "https://node.glamlink.net/api/v1/videos/";

export default HOST;